import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccountMobile = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.30923 3.29562C6 3.85811 6 4.60541 6 6.1L6 17.9C6 19.3946 6 20.1419 6.30923 20.7044C6.53778 21.1201 6.87989 21.4622 7.29562 21.6908C7.85811 22 8.60541 22 10.1 22H13.9C15.3946 22 16.1419 22 16.7044 21.6908C17.1201 21.4622 17.4622 21.1201 17.6908 20.7044C18 20.1419 18 19.3946 18 17.9V6.1C18 4.60541 18 3.85811 17.6908 3.29562C17.4622 2.87989 17.1201 2.53778 16.7044 2.30923C16.1419 2 15.3946 2 13.9 2L10.1 2C8.60541 2 7.85811 2 7.29562 2.30923C6.87989 2.53778 6.53778 2.87989 6.30923 3.29562ZM10.7356 4C10.2741 4 9.8999 4.32427 9.8999 4.72429C9.8999 5.1243 10.2741 5.44857 10.7356 5.44857L13.2316 5.44857C13.6932 5.44857 14.0673 5.1243 14.0673 4.72429C14.0673 4.32427 13.6932 4 13.2316 4H10.7356Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgAccountMobile);
export default ForwardRef;
